import { connect } from 'react-redux';

import ProductSummary from './productSummary';
import { getCartData, getOrderBuilderData, getCheckboxSettingsData } from '../orderBuilder/store/selectors';
import { addOrderToCart, loadCheckboxSettings } from '../orderBuilder/store/action-creators';

const mapStateToProps = (state) => ({
  cartData: getCartData(state),
  orderBuilderData: getOrderBuilderData(state),
  checkboxSettingsData: getCheckboxSettingsData(state)
});

const mapDispatchToProps = {
  addOrderToCart,
  loadCheckboxSettings,
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductSummary);